








































import {Component, Mixins} from 'vue-property-decorator';
import {DuplicatedCase, DuplicatedCaseDialogRequest, TableHeader} from '@/model/CommonModel';
import CommonPaginatedTable from '@/components/table/CommonPaginatedTable.vue';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import DefaultPaginateMixin from '@/views/DefaultPaginateMixin';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import TextInput from '@/components/input/TextInput.vue';
import IconButton from '@/components/button/IconButton.vue';

@Component({
  components: {TextInput, CommonPromptDialog, CommonPaginatedTable, CommonButton, IconButton},
  mixins: [DefaultPaginateMixin, DialogEventsMixin]
})
export default class DuplicatedCaseDialog extends Mixins(DefaultPaginateMixin, DialogEventsMixin) {

  private visible: boolean = false;
  private typeOfReport: string;
  private isTrialCaseType: boolean = false;
  private values: DuplicatedCase[] = [];
  private onConfirm: (context: any) => void;
  private onCancel: () => void;
  private hasEmptyItem: boolean = false;

  get getColumns() {
    return this.isTrialCaseType
        ?
        [
          {
            columnId: 'caseNo',
            columnLabel: this.$root.$t('message.case.duplicationCheck.caseNo').toString(),
            filtered: 'N',
            visible: 'Y'
          },
          {
            columnId: 'recentDateTime',
            columnLabel: this.$root.$t('message.case.duplicationCheck.recentDateTimeInHeader').toString(),
            filtered: 'N',
            visible: 'Y'
          },
          {
            columnId: 'reportType',
            columnLabel: this.$root.$t('message.case.duplicationCheck.reportType').toString(),
            filtered: 'N',
            visible: 'Y'
          },
          {
            columnId: 'organisation',
            columnLabel: this.$root.$t('message.case.duplicationCheck.organisation').toString(),
            filtered: 'N',
            visible: 'Y'
          },
          {
            columnId: 'sponsorStudyNumber',
            columnLabel: this.$root.$t('message.case.duplicationCheck.sponsorStudyNo').toString(),
            filtered: 'N',
            visible: 'Y'
          },
          {
            columnId: 'investigationNumber',
            columnLabel: this.$root.$t('message.case.duplicationCheck.investigationNumber').toString(),
            filtered: 'N',
            visible: 'Y'
          },
          {
            columnId: 'productName',
            columnLabel: this.$root.$t('message.case.duplicationCheck.product').toString(),
            filtered: 'N',
            visible: 'Y'
          },
          {
            columnId: 'aeTerm',
            columnLabel: this.$root.$t('message.case.duplicationCheck.reactionEventColumnName').toString(),
            filtered: 'N',
            visible: 'Y'
          },
          {
            columnId: 'aeStartDate',
            columnLabel: this.$root.$t('message.case.duplicationCheck.aeStartDate').toString(),
            filtered: 'N',
            visible: 'Y'
          }
        ]
        :
        [
          {
            columnId: 'caseNo',
            columnLabel: this.$root.$t('message.case.duplicationCheck.caseNo').toString(),
            filtered: 'N',
            visible: 'Y'
          },
          {
            columnId: 'recentDateTime',
            columnLabel: this.$root.$t('message.case.duplicationCheck.recentDateTimeInHeader').toString(),
            filtered: 'N',
            visible: 'Y'
          },
          {
            columnId: 'reportType',
            columnLabel: this.$root.$t('message.case.duplicationCheck.reportType').toString(),
            filtered: 'N',
            visible: 'Y'
          },
          {
            columnId: 'patientName',
            columnLabel: this.$root.$t('message.case.duplicationCheck.patientName').toString(),
            filtered: 'N',
            visible: 'Y'
          },
          {
            columnId: 'age',
            columnLabel: this.$root.$t('message.case.duplicationCheck.age').toString(),
            filtered: 'N',
            visible: 'Y'
          },
          {
            columnId: 'sex',
            columnLabel: this.$root.$t('message.case.duplicationCheck.sex').toString(),
            filtered: 'N',
            visible: 'Y'
          },
          {
            columnId: 'productName',
            columnLabel: this.$root.$t('message.case.duplicationCheck.product').toString(),
            filtered: 'N',
            visible: 'Y'
          },
          {
            columnId: 'aeTerm',
            columnLabel: this.$root.$t('message.case.duplicationCheck.reactionEventColumnName').toString(),
            filtered: 'N',
            visible: 'Y'
          },
          {
            columnId: 'aeStartDate',
            columnLabel: this.$root.$t('message.case.duplicationCheck.aeStartDate').toString(),
            filtered: 'N',
            visible: 'Y'
          }
        ];
  }

  get isVisible() {
    return this.visible;
  }

  get getValues() {
    return this.values;
  }

  get getPageInfo() {
    return {
      menuId: '',
      pageNo: 1,
      rowCount: this.values.length,
      totalCount: this.values.length,
      totalPage: 1
    };
  }

  get isLoading() {
    return this.loading;
  }

  get content() {
    return this.hasEmptyItem
        ? this.$t('message.case.duplicationCheck.hasEmptyItemCases').toString()
        : this.values?.length > 0
            ? this.$t('message.case.duplicationCheck.duplicatedCases').toString()
            : this.$t('message.case.duplicationCheck.noDuplicatedCases').toString();
  }

  get width() {
    return (this.values ?? []).length === 0 ? '450px' : '1400px';
  }

  get tableBodyHeight() {
    return '280px';
  }

  get getColgroupSumWidth() {
    return this.isTrialCaseType ? '1940px' : '1655px';
  }

  public mounted() {
    this.$modal
        .getEventBus()
        .$on('showDuplicatedCasesDialog', (params: DuplicatedCaseDialogRequest) => {
          this.show(params);
        });

    this.$modal.getEventBus().$on('hideDuplicatedCaseDialog', () => this.cancel());
  }

  public show(request: DuplicatedCaseDialogRequest) {
    this.values = request.duplicatedCases;
    this.typeOfReport = request.typeOfReport;
    this.isTrialCaseType = request.typeOfReport === '2';
    this.onConfirm = request.onConfirm;
    this.onCancel = request.onCancel;
    this.visible = true;
    this.loading = false;
    this.hasEmptyItem = request.hasEmptyItem;
  }

  public onClose() {
    this.hide();
  }

  public cancel() {
    if (this.onCancel instanceof Function) {
      this.onCancel();
    }
    this.hide();
  }

  public onOk() {
    this.onConfirm(this);
    this.hide();
  }

  private hide() {
    this.visible = false;
  }

  public afterClosed() {
    this.values = [];
    this.loading = false;
  }

  public destroyed() {
    this.$modal.getEventBus().$off('showDuplicatedCasesDialog');
    this.$modal.getEventBus().$off('hideDuplicatedCaseDialog');
  }
}
